import { WIDGET_FILTER } from "@/constants";

import { ReachInfoLink } from "../ReachWidget";
import Reach, { ExternalReachWidgetProps } from "./Reach";
const ReachOverTimeSocial = (props: ExternalReachWidgetProps) => (
  <Reach
    {...props}
    extraHeader={<ReachInfoLink />}
    title={L.REPORTS_WIDGET_DEFAULT_TITLE_REACH_SOCIAL_INSIGHTS}
    description={L.REPORTS_WIDGET_DEFAULT_DESCRIPTION_REACH_SOCIAL_INSIGHTS}
    filterKey={WIDGET_FILTER.MEDIA_TYPE}
  />
);

export default ReachOverTimeSocial;
